import { ActionType, useActionState } from "../../../status/state/actions.state";
import { StyledToolbarButton, StyledTooltip } from "../../../../shared/styles/components/integrations.styles";

import plusIcon from '@ingka/ssr-icon/paths/plus';
import { useMemo } from 'react';
import { useSelection } from '../../state/selection.state';

export const BulkEditAddButton = () => {
   const { isAnySelected } = useSelection();

   const tooltipText = useMemo(() => {
      return !isAnySelected
         ? 'You need to make a selection to bulk add'
         : 'Add new material to all selected items';
   }, [isAnySelected]);

   return (
      <StyledTooltip title={tooltipText}>
         <span>
            <StyledToolbarButton
               ssrIcon={plusIcon}
               iconOnly={true}
               small={true}
               disabled={!isAnySelected}
               onClick={() => useActionState.setState({ actionType: ActionType.bulkAdding })}
            />
         </span>
      </StyledTooltip>
   );
};